// import React, { useState, useEffect, useMemo } from "react";
// import { Typography, Grid } from "@mui/material";
// import CustomTable from "components/TableExplanded/Table";
// import CustomPagination from "components/TableExplanded/Pagination";
// import useProductData from "pages/Pawn/Products/AllProduct/data/data";
// import useColumns from "pages/Pawn/Products/AllProduct/columns/mainColumns";
// import useColumnsTwo from "pages/Pawn/Products/AllProduct/columns/subColumns";
// import Modal from "components/Modal/Pawn/BuyProduct/ModalCreate";
// import ViewModal from "components/Modal/Pawn/View/ViewBuyItems";
// import SearchBar from "components/TableExplanded/SearchBar";
// import api from "_api";

// const AllProduct = ({ className }) => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [isModalOpen, setModalOpen] = useState(false);
//   const [isViewModalOpen, setViewModalOpen] = useState(false);
//   const [selectedProduct, setProduct] = useState(null);
//   const [viewProduct, setViewProduct] = useState(null);
//   const [fetchData, setFetchData] = useState();
//   const [searchQuery, setSearchQuery] = useState(""); // Store the search query
//   const [dataLength, setDataLength] = useState(0);
//   const fetchProductData = async () => {
//     try {
//       const { data, isStatus } = await api.product.getAllOrders();
//       if (isStatus) setFetchData(data);
//     } catch (error) {
//       console.error("Error fetching product data:", error);
//     }
//   };
//   // const fetchProductData = async ({ search = "", page = 1, limit = 10 }) => {
//   //   try {
//   //     const { data, isStatus } = await api.product.getAllOrdersV2({ search, page, limit });
//   //     if (isStatus) setFetchData(data);
//   //     setFetchData(data)
//   //   } catch (error) {
//   //     console.error("Error fetching product data:", error);
//   //   }
//   // };

//   useEffect(() => {
//     fetchProductData();
//   }, []);

//   const handleModalOpen = () => {
//     setModalOpen(!isModalOpen);
//     if (selectedProduct && isModalOpen) setProduct(null);
//   };

//   const handleViewOpen = () => {
//     setViewModalOpen(!isViewModalOpen);
//     if (viewProduct && isViewModalOpen) setViewProduct(null);
//   };

//   const data = useProductData(fetchData);
//   const columns = useColumns(
//     setViewProduct,
//     setProduct,
//     handleViewOpen,
//     handleModalOpen
//   );
//   const columnsInside = useColumnsTwo();
//   const visibleColumns = columns.filter((col) => col.showInFilter);
//   // const filteredData = useMemo(() => {
//   //   if (!searchQuery) return data; // If no search query, return all data

//   //   return data.filter((row) => {
//   //     return visibleColumns.some((column) => {
//   //       const cellValue = row[column.accessor]?.toString()?.toLowerCase();
//   //       return cellValue && cellValue.includes(searchQuery.toLowerCase());
//   //     });
//   //   });
//   // }, [data, searchQuery, visibleColumns]);

//   const filteredData = useMemo(() => {
//     if (!searchQuery) return data;
//     return data.filter((row) => {
//       return visibleColumns.some((column) => {
//         const cellValue = row[column.accessor]?.toString()?.toLowerCase();
//         return cellValue && cellValue.includes(searchQuery.toLowerCase());
//       });
//     });
//   }, [data, searchQuery, visibleColumns]);

//   const handleSearchChange = (event) => {
//     // Check if event.target and event.target.value are defined
//     if (
//       event &&
//       event.target &&
//       event.target.value !== undefined &&
//       event.target.value !== null
//     ) {
//       setSearchTerm(event.target.value.toLowerCase());
//       setSearchQuery(event.target.value);
//     } else {
//       console.error("Event target or value is undefined");
//     }
//     setPage(0);
//   };

//   const handleClear = () => {
//     setSearchTerm("");
//     setPage(0);
//   };

//   const handlePageChange = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleRowsPerPageChange = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   return (
//     <div className={className}>
//       <Grid container spacing={2} style={{ marginBottom: "16px" }}>
//         <Grid
//           item
//           xs={12}
//           sm={12}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <Typography component="div" style={{ fontSize: "32px" }}>
//             รายการทั้งหมด
//           </Typography>
//         </Grid>
//       </Grid>

//       <SearchBar
//         columns={columns}
//         searchTerm={setSearchTerm}
//         visibleColumns={visibleColumns} // กรองคอลัมน์ที่ต้องการแสดง
//         handleSearchChange={handleSearchChange}
//         handleClear={handleClear}
//         fetchData={fetchData}
//         QRCode={false}
//       />

//       <CustomTable
//         columns={columns}
//         columnsInside={columnsInside}
//         searchTerm={searchTerm}
//         data={filteredData}
//         setDataLength={setDataLength}
//         page={page}
//         rowsPerPage={rowsPerPage}
//       />
//       <CustomPagination
//         count={searchTerm ? dataLength : filteredData.length} // กรณีที่มีการค้นหา
//         page={page}
//         rowsPerPage={rowsPerPage}
//         onPageChange={handlePageChange}
//         onRowsPerPageChange={handleRowsPerPageChange}
//       />

//       <Modal
//         open={isModalOpen}
//         onClose={handleModalOpen}
//         selectedProduct={selectedProduct}
//         fetchProductData={fetchProductData}
//       />

//       <ViewModal
//         open={isViewModalOpen}
//         onClose={handleViewOpen}
//         selectedProduct={viewProduct}
//         fetchProductData={fetchProductData}
//       />
//     </div>
//   );
// };

// export default AllProduct;

import React, { useState, useEffect, useMemo } from "react";
import { Typography, Grid } from "@mui/material";
import CustomTable from "components/TableExplanded/Table";
import CustomPagination from "components/TableExplanded/Pagination";
import useProductData from "pages/Pawn/Products/AllProduct/data/data";
import useColumns from "pages/Pawn/Products/AllProduct/columns/mainColumns";
import useColumnsTwo from "pages/Pawn/Products/AllProduct/columns/subColumns";
import Modal from "components/Modal/Pawn/BuyProduct/ModalCreate";
import ViewModal from "components/Modal/Pawn/View/ViewBuyItems";
import SearchBar from "components/TableExplanded/SearchBar";
import api from "_api";

const AllProduct = ({ className }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [selectedProduct, setProduct] = useState(null);
  const [viewProduct, setViewProduct] = useState(null);
  const [fetchData, setFetchData] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // Store the search query
  const [dataLength, setDataLength] = useState(0);
  console.log("fetch:", fetchData);

  // Fetch product data based on search, page, and limit
  const fetchProductData = async ({
    search = "",
    searchIdcard = "",
    searchName = "",
    searchDate = "",
    page = 1,
    limit = 10,
  }) => {
    try {
      const { data, isStatus, total } = await api.product.getAllOrdersV2({
        search,
        searchIdcard,
        searchName,
        searchDate,
        page,
        limit,
      });
      if (isStatus) {
        setFetchData(data);
        setDataLength(total); // Set the total data length for pagination
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  useEffect(() => {
    fetchProductData({
      search: searchQuery,
      page: page + 1,
      limit: rowsPerPage,
    });
  }, [searchQuery, page, rowsPerPage]); // Fetch data whenever searchQuery, page, or rowsPerPage changes

  const handleModalOpen = () => {
    setModalOpen(!isModalOpen);
    if (selectedProduct && isModalOpen) setProduct(null);
  };

  const handleViewOpen = () => {
    setViewModalOpen(!isViewModalOpen);
    if (viewProduct && isViewModalOpen) setViewProduct(null);
  };

  const data = useProductData(fetchData);
  const columns = useColumns(
    setViewProduct,
    setProduct,
    handleViewOpen,
    handleModalOpen
  );
  const columnsInside = useColumnsTwo();
  const visibleColumns = columns.filter((col) => col.showInFilter);

  // const filteredData = useMemo(() => {
  //   if (!searchQuery) return data; // If no search query, return all data

  //   return data.filter((row) => {
  //     return visibleColumns.some((column) => {
  //       const cellValue = row[column.accessor]?.toString()?.toLowerCase();
  //       return cellValue && cellValue.includes(searchQuery.toLowerCase());
  //     });
  //   });
  // }, [data, searchQuery, visibleColumns]);

  const handleSearchChange = (event) => {
    if (
      event &&
      event.target &&
      event.target.value !== undefined &&
      event.target.value !== null
    ) {
      const query = event.target.value.toLowerCase();
      setSearchTerm(query);
      setSearchQuery(query); // Update searchQuery with the search term
    } else {
      console.error("Event target or value is undefined");
    }
    setPage(0); // Reset page when search changes
  };

  const handleClear = () => {
    setSearchTerm("");
    setSearchQuery(""); // Reset searchQuery when clearing the search
    setPage(0); // Reset page when clearing search
    fetchProductData({ search: "", page: 1, limit: rowsPerPage });
  };

  const handlePageChange = (event, newPage) => {
    if (searchTerm != null) {
      setSearchQuery(searchTerm.order_code);
    }
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset page when rows per page change
  };

  return (
    <div className={className}>
      <Grid container spacing={2} style={{ marginBottom: "16px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography component="div" style={{ fontSize: "32px" }}>
            รายการทั้งหมด
          </Typography>
        </Grid>
      </Grid>

      <SearchBar
        columns={columns}
        searchTerm={setSearchTerm}
        visibleColumns={visibleColumns} // กรองคอลัมน์ที่ต้องการแสดง
        handleSearchChange={handleSearchChange}
        handleClear={handleClear}
        // fetchData={() => fetchProductData({ search: searchQuery, page: page + 1, limit: rowsPerPage })}
        fetchData={fetchData}
        handleSearchClick={(filters) => {
          fetchProductData({
            search: filters.order_code || "",
            searchIdcard: filters.idcard || "",
            searchName: filters.customer_name || "",
            searchDate: filters.created_date || "",
            page: 1,
            limit: rowsPerPage,
          });
        }}
        QRCode={false}
      />
      <CustomTable
        columns={columns}
        columnsInside={columnsInside}
        searchTerm={searchTerm}
        data={data}
        setDataLength={setDataLength}
        page={page}
        rowsPerPage={rowsPerPage}
      />
      <CustomPagination
        count={dataLength} // กรณีที่มีการค้นหา
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <Modal
        open={isModalOpen}
        onClose={handleModalOpen}
        selectedProduct={selectedProduct}
        // fetchProductData={() => fetchProductData({ search: searchQuery, page: page + 1, limit: rowsPerPage })}
        fetchProductData={fetchData}
      />

      <ViewModal
        open={isViewModalOpen}
        onClose={handleViewOpen}
        selectedProduct={viewProduct}
        // fetchProductData={() => fetchProductData({ search: searchQuery, page: page + 1, limit: rowsPerPage })}
        fetchProductData={fetchData}
      />
    </div>
  );
};

export default AllProduct;
